import React, { useRef } from 'react';
import Container from './MindMap.styl';
import Markdown from '../../atoms/Markdown';

export type VideoProps = {
  authorization?: string;
  mediaCode?: string;
  text: string;
  onClose: () => void;
  opened?: boolean;
};

// Função para copiar conteúdo formatado (HTML + texto plano)
const copyFormattedContent = async (element: HTMLElement | null, fallbackText: string) => {
  if (!element) return;

  try {
    // Tenta usar a Clipboard API moderna que suporta múltiplos formatos
    if (navigator.clipboard && window.ClipboardItem) {
      const html = element.innerHTML;
      const plainText = element.innerText || element.textContent || fallbackText;

      const htmlBlob = new Blob([html], { type: 'text/html' });
      const textBlob = new Blob([plainText], { type: 'text/plain' });

      const clipboardItem = new ClipboardItem({
        'text/html': htmlBlob,
        'text/plain': textBlob,
      });

      await navigator.clipboard.write([clipboardItem]);
      console.log('Conteúdo formatado copiado com sucesso');
      return;
    }
  } catch (err) {
    console.warn('Clipboard API falhou, tentando método alternativo:', err);
  }

  // Fallback: usa o método de seleção + execCommand
  try {
    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(element);
    selection?.removeAllRanges();
    selection?.addRange(range);

    const successful = document.execCommand('copy');
    selection?.removeAllRanges();

    if (successful) {
      console.log('Conteúdo copiado usando execCommand');
      return;
    }
  } catch (err) {
    console.warn('execCommand falhou, usando fallback de texto plano:', err);
  }

  // Último fallback: copia apenas texto plano
  try {
    const plainText = element.innerText || element.textContent || fallbackText;
    
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(plainText);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = plainText;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.opacity = '0';
      
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    
    console.log('Texto plano copiado como fallback');
  } catch (err) {
    console.error('Falha ao copiar conteúdo:', err);
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default ({
  authorization,
  mediaCode,
  text,
  onClose,
  opened = false,
}: VideoProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  if (!opened) {
    return null;
  }

  return (
    <Container className="smartplayer__mindMap">
      <div className="mindmap__backdrop" onClick={() => onClose()}></div>
      <div className="mindmap__container">
        <div className="mindmap__heading">
          <h1 className="mindmap__title">Mapa Mental</h1>
          <button type="button" className="mindmap__btn mindmap__btn--close" onClick={() => onClose()}>
            <svg className="svg-inline--fa fa-xmark" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
              <path fill="currentColor" d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"></path>
            </svg>
          </button>
        </div>
        <hr className="mindmap_hr" />
        <div className="mindmap__content" ref={contentRef}>
          <Markdown>
            {text}
          </Markdown>
        </div>
        <div className="mindmap__footer">
          <button className="mindmap__btn mindmap__btn--copy" onClick={() => copyFormattedContent(contentRef.current, text)}>
            Copiar
          </button>
          {/* <button className="mindmap__btn mindmap__btn--download" disabled>
            Download
          </button> */}
        </div>
      </div>
    </Container>
  );
};
